import type { SelectedOs } from "@/modules/compute/os/os.ts";
import { OsInfo } from "@/modules/compute/os/OsInfo.tsx";

export function VmOs({ value }: { value: SelectedOs }) {
    return (
        <div className="whitespace-nowrap">
            {value.os_name === "service" ? <VmServiceOs value={value} /> : <OsInfo os={value} />}
        </div>
    );
}

function VmServiceOs({ value }: { value: SelectedOs }) {
    const { os_version } = value;
    return (
        <>
            <OsInfo os={{ os_name: "service", os_version }} />
            <div className="text-muted font-size-small">Managed service</div>
        </>
    );
}
